import React from 'react';
import '../styles/AppDownloadPage.css';
import appIcon from '../../assets/logo_white_bg.png';

const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.indiapropertys.app360';
const APP_STORE_URL =
  'https://apps.apple.com/in/app/360coordinates/id6768521931';

const PlayStoreIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden width="32" height="32">
    <path d="M3.609 1.814L13.792 12 3.609 22.186a.996.996 0 0 1-.609-.92V2.734a.996.996 0 0 1 .609-.92zm10.89 10.893l2.302 2.302-7.134 4.115L7.88 16.42l6.619-5.713zm.805-.707L8.469 5.584l2.114-1.219 7.134 4.115-2.302 2.302zM21.5 11.5c.5.3.5.7 0 1l-3.25 1.875L15.75 12l2.5-2.375 3.25 1.875z" />
  </svg>
);

const AppStoreIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden width="32" height="32">
    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
  </svg>
);

const AppDownloadPage = () => {
  const handleAndroidDownload = () => {
    window.open(PLAY_STORE_URL, '_blank', 'noopener,noreferrer');
  };

  const handleIOSDownload = () => {
    window.open(APP_STORE_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="appdownload-coordinates-container">
      <section className="appdownload-coordinates-download-section">
        <div className="appdownload-coordinates-logo">
          <img
            src={appIcon}
            alt=""
            className="appdownload-coordinates-app-icon"
          />
          <div className="appdownload-coordinates-logo-sub">360Coordinates</div>
        </div>
        <h2 className="appdownload-coordinates-section-title">Get the App</h2>
        {/* <p className="appdownload-coordinates-subtitle">No signup required to download</p> */}

        <div className="appdownload-coordinates-store-buttons">
          <button
            type="button"
            className="appdownload-coordinates-store-btn appdownload-coordinates-play-store"
            onClick={handleAndroidDownload}
          >
            <span className="appdownload-coordinates-btn-icon">
              <PlayStoreIcon />
            </span>
            <span className="appdownload-coordinates-btn-text">
              <span className="appdownload-coordinates-btn-small">GET IT ON</span>
              <span className="appdownload-coordinates-btn-large">Google Play</span>
            </span>
          </button>

          <button
            type="button"
            className="appdownload-coordinates-store-btn appdownload-coordinates-app-store"
            onClick={handleIOSDownload}
          >
            <span className="appdownload-coordinates-btn-icon">
              <AppStoreIcon />
            </span>
            <span className="appdownload-coordinates-btn-text">
              <span className="appdownload-coordinates-btn-small">Download on the</span>
              <span className="appdownload-coordinates-btn-large">App Store</span>
            </span>
          </button>
        </div>
      </section>

      <footer className="appdownload-coordinates-footer">
        <p>© {new Date().getFullYear()} 360Coordinates. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default AppDownloadPage;
